import { datadogRum } from '@datadog/browser-rum'
import { PRIVACY_CONSUMER_COMPONENT } from '../constants/constants'
import { fptiCustomEvent } from './fpti'

// Constants
const EVENT_NAME = 'DATADOG_RUM_initialization_failed'
const SANDBOX = 'SANDBOX'
const PRODUCTION = 'PRODUCTION'
const PAYPAL_DEBUG_ID = 'Paypal-Debug-Id'

// Configuration - Moved to constants for clarity and potential future configuration
const TRACE_URLS = {
  [PRODUCTION]: 'https://go/ddprod/trace?',
  [SANDBOX]: 'https://go/ddsb/trace?',
  default: 'https://go/ddqa/trace?',
}

const CAL_LOG_URLS = {
  [PRODUCTION]: 'https://go/ddprod/tocal?',
  [SANDBOX]: 'https://go/ddsb/tocal?',
  default: 'https://go/ddqa/tocal?',
}

// Optimized URL builders - Using template literals and direct lookup
function getDDTraceLink(correlationId, environment) {
  return `${TRACE_URLS[environment] || TRACE_URLS.default}${correlationId}`
}

function getCalLogLink(correlationId, environment) {
  return `${CAL_LOG_URLS[environment] || CAL_LOG_URLS.default}${correlationId}`
}

// Optimized correlation ID handling
function addCorrelationIdToContext(event, correlationId, environment) {
  if (correlationId && typeof correlationId === 'string') {
    event.context.correlationId = correlationId
    event.context['dd-trace-url'] = getDDTraceLink(correlationId, environment)
    event.context['external-cal-url'] = getCalLogLink(
      correlationId,
      environment,
    )
  }
}

const getDefaultConfig = (environment) => ({
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: 'mask',
  startSessionReplayRecordingManually: true,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  enablePrivacyForActionName: true,
  excludedActivityUrls: [/log/i, /fpti/i, /tealeaf/i, /tracking\/ts/i],
  allowedTracingUrls: [
    (url) =>
      !(
        url.includes('log') ||
        url.includes('fpti') ||
        url.includes('tealeaftarget') ||
        url.includes('tracking/ts')
      ),
  ],
  beforeSend(event, context) {
    if (event.type === 'resource') {
      let correlationId = context?.response?.headers?.get(PAYPAL_DEBUG_ID)
      correlationId =
        context?.xhr?.getResponseHeader(PAYPAL_DEBUG_ID) || correlationId
      addCorrelationIdToContext(event, correlationId, environment)
    }
    return true
  },
})

// Optimized RUM initialization
export const loadDataDogRumInfo = (dataDogConfig) => {
  try {
    const { encryptedAccountNumber, country, environment } =
      dataDogConfig.appData
    const configWithoutAppData = { ...dataDogConfig } // Clone to avoid modifying original object
    delete configWithoutAppData.appData

    datadogRum.init({
      ...getDefaultConfig(environment),
      ...configWithoutAppData,
    })

    datadogRum.setUser({ id: encryptedAccountNumber, country })
    datadogRum.setGlobalContextProperty('user_country', country)
  } catch (error) {
    fptiCustomEvent(EVENT_NAME, {
      event_name: EVENT_NAME,
      error_message: error.message,
      product: PRIVACY_CONSUMER_COMPONENT,
    })
  }
}
